<template>
  <div>
    <el-descriptions :column="column" :direction="direction" border :size="size">

      <template v-for="(item, index) in list">
        <el-descriptions-item
            v-if="checkAccount(item.account)"
            :key="index"
            :label="item.title || item.label"
            :span="item.span?item.span:1"
        >
            <template v-if="item.type === 'pic_title'">
              <template v-if="form[item.img_key]">
                <el-image
                    class="m-r-12"
                    v-for="pic in form[item.img_key]"
                    :key="pic"
                    style="width: 50px; height: 50px"
                    :src="pic"
                    :preview-src-list="form[item.img_key]"
                ></el-image>
              </template>
              <div class="w-200" v-else>
                <span>{{ form[item.key] === 0 ? 0 : form[item.key] || "" }}</span>
              </div>
            </template>
            <template v-if="item.type === 'pic'">
              <template v-if="form[item.key]">
                <el-image
                    class="m-r-12"
                    v-for="pic in form[item.key]"
                    :key="pic"
                    style="width: 50px; height: 50px"
                    :src="pic"
                    :preview-src-list="form[item.key]"
                ></el-image>
              </template>
            </template>
            <template v-else-if="item.type === 'img'">
              <template v-if="form[item.key]">
                <el-image
                    class="m-r-12"
                    :style="`width: ${item.width || '50px'}; height: ${
                item.height || '50px'
              }`"
                    :src="form[item.key]"
                    :preview-src-list="[form[item.key]]"
                ></el-image>
              </template>
            </template>
            <span v-else-if="item.type === 'status'">
          <el-tag :type="getType(form[item.key], item.typeList)">
            {{ form[item.key] | filterlistStatus(item.typeList) }}
          </el-tag>
        </span>
            <template v-else-if="item.type === 'radio'">
              <el-tag :type="getType(form[item.key], item.options)">
                {{ form[item.key] | filterlistStatus(item.options) }}
              </el-tag>
            </template>
            <template v-else-if="item.type === 'input'">
              <el-input
                  v-model="formData[item.key]"
                  :placeholder="item.placeholder || '请输入'"
                  :maxlength="item.maxlength"
                  :disabled="item.disabled"
              >
              </el-input>
            </template>
            <template v-else-if="item.type === 'inputNumber'">
              <el-input-number
                  v-model="formData[item.key]"
                  :placeholder="item.placeholder || '请输入'"
                  :maxlength="item.maxlength"
                  :disabled="item.disabled"
                  :min="item.min || 0"
                  :max="item.max || 9999999"
                  :controls="item.controls || false"
                  :precision="item.precision || 0"
              >
              </el-input-number>
            </template>
            <template v-else-if="item.type === 'textarea'">
              <el-input
                  v-model="formData[item.key]"
                  :placeholder="item.placeholder || '请输入'"
                  :maxlength="item.maxlength"
                  :disabled="item.disabled"
                  :show-word-limit = "item.showWordLimit"
                  type="textarea"
              >
              </el-input>
            </template>
            <template v-else-if="item.type === 'input_size'">
              <div class="flex">
                <el-input
                    v-model="formData[item.key]"
                    :placeholder="'长'"
                    :maxlength="item.maxlength"
                    :disabled="item.disabled"
                >
                </el-input>
                *
                <el-input
                    v-model="formData[item.key2]"
                    :placeholder=" '宽'"
                    :maxlength="item.maxlength"
                    :disabled="item.disabled"
                >
                </el-input>
                *
                <el-input
                    v-model="formData[item.key3]"
                    :placeholder="'高'"
                    :maxlength="item.maxlength"
                    :disabled="item.disabled"
                >
                </el-input>
              </div>
            </template>
            <template v-else-if="item.type === 'select'">
              <el-select
                  :multiple="item.multiple || false"
                  :collapse-tags="item.collapseTags"
                  v-model="formData[item.key]"
                  :value-key="item.indexKey || 'id'"
                  :clearable="!!item.clearable || true"
                  :filterable="!!item.filterable || true"
                  :placeholder="item.placeholder || '请选择'"
                  @change="changeValue($event, item.key)"
                  :remote="item.remote || false"
                  :disabled="item.disabled || false"
                  :remote-method="item.remote_method"
              >
                <el-option
                    v-for="(v, index) in item.options"
                    :key="index"
                    :label="(item.resetKey && v[item.resetKey.label]) || item.name"
                    :value="(item.resetKey && v[item.resetKey.value]) || item.id"
                />
              </el-select>
            </template>
            <template v-else-if="item.type === 'select_returnArr'">
              <el-select
                  :multiple="item.multiple || false"
                  :collapse-tags="item.collapseTags"
                  v-model="formData[item.key]"
                  :value-key="item.indexKey || 'id'"
                  :clearable="!!item.clearable || true"
                  :filterable="!!item.filterable || true"
                  :placeholder="item.placeholder || '请选择'"
                  @change="changeValueMultiple($event, item.key,item.options,item.indexKey)"
                  :remote="item.remote || false"
                  :disabled="item.disabled || false"
                  :remote-method="item.remote_method"
              >
                <el-option
                    v-for="(v, index) in item.options"
                    :key="index"
                    :label="(item.resetKey && v[item.resetKey.label]) || item.name"
                    :value="(item.resetKey && v[item.resetKey.value]) || item.id"
                />
              </el-select>
            </template>
            <template v-else-if="item.type === 'select_multiple'">
              <el-select
                  :multiple="true"
                  :collapse-tags="item.collapseTags"
                  v-model="formData[item.key]"
                  :value-key="item.indexKey || 'id'"
                  :clearable="!!item.clearable || true"
                  :filterable="!!item.filterable || true"
                  :placeholder="item.placeholder || '请选择'"
                  @change="changeValueMultiple($event, item.key,item.options,item.indexKey)"
                  :remote="item.remote || false"
                  :disabled="item.disabled || false"
                  :remote-method="item.remote_method"
              >
                <el-option
                    v-for="(v, index) in item.options"
                    :key="index"
                    :label="(item.resetKey && v[item.resetKey.label]) || item.name"
                    :value="(item.resetKey && v[item.resetKey.value]) || item.id"
                />
              </el-select>
            </template>
            <template v-else-if="item.type === 'dateTimePicker'">
              <el-date-picker
                  style="width: 198px"
                  v-model="formData[item.key]"
                  type="daterange"
                  range-separator="-"
                  :start-placeholder=" '请选择'"
                  :end-placeholder=" '请选择'"
                  :value-format="item.valueFormat || 'yyyy-MM-dd'"
                  :format="item.valueFormat || 'yyyy-MM-dd'"
                  @change="changeValue($event, item.key)"
              />
            </template>
            <!-- 时间选择器 -->
            <template v-else-if="item.type === 'datetime'">
              <el-date-picker
                  style="width: 198px"
                  v-model="formData[item.key]"
                  type="datetime"
                  :placeholder="item.placeholder || '请选择'"
                  :value-format="item.valueFormat || 'yyyy-MM-dd HH:mm:ss'"
                  :picker-options="item.pickerOptions"
                  @change="changeValue($event, item.key)"
              />
            </template>
            <template v-else-if="item.type === 'rich_text'">
              <div
                  v-html="form[item.key]"
                  class="rich-text"
              ></div>
            </template>
          <template v-else-if="item.type === 'link'">
            <div
                class="cursor main-color1"
                style="font-size: 14px;font-weight: 500;"
                @click="handleLinkClick(form, item.click)">
              {{ form[item.key] }}
            </div>
          </template>
            <div
                :style="{
            'max-width': column > 3 ? '20vw' : '100%',
            width: item.width || ''
          }"
                v-else-if="item.type === 'number'"
            >
              {{ Number(form[item.key]).toFixed(item.toFixed) }}
            </div>
            <div
                :style="{
            'max-width': column > 3 ? '20vw' : '100%',
            width: item.width || ''
          }"
                v-else
            >
              <div v-if="item.render">
                {{
                  item.render(form[item.key], form) === 0
                      ? 0
                      : item.render(form[item.key], form) || ""
                }}
              </div>
              <div v-else>
                {{ form[item.key] }}
              </div>
            </div>
        </el-descriptions-item>
      </template>
      <slot></slot>
    </el-descriptions>
  </div>
</template>

<script>
import {UserModule} from "@/store/modules/user";

export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    form: {
      type: Object,
      default: () => ({})
    },
    column: {
      type: Number,
      default: 4
    },
    direction: {
      type: String,
      default: "horizontal"
    },
    size:{
      type: String,
      default: "''"
    }
  },
  watch: {
    form: {
      handler(val) {
        this.formData = val;
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      formData: {}
    };
  },
  filters: {
    filterlistStatus(val, list) {
      if (!list) {
        return "";
      }
      let obj = list.find((v) => v.id == val);
      if (obj) return obj.name;
      else return "";
    }
  },
  methods: {
    handleLinkClick(data, clickFun) {
      if (clickFun) {
        this.$emit(clickFun, data);
      }else {
        this.$emit("linkClick", data);
      }
    },
    checkAccount(exceptAccounts) {
      if (exceptAccounts) {
        console.log(exceptAccounts)
        const userAccounts = UserModule.accountType
        if (exceptAccounts instanceof Array) {
          return userAccounts.some(a => {
            return exceptAccounts.includes(a)
          })
        }
        if (exceptAccounts instanceof String) {
          return userAccounts.some(a => {
            return exceptAccounts == a
          })
        }
      }
      return true;
    },
    getType(val, list) {
      if (!val || !list) {
        return "";
      }
      let obj = list.find((v) => v.id == val);
      if (obj) return obj.type;
      else return "";
    },
    changeValue(value, key) {
      this.$emit("changeValue", {
        key,
        value
      });
    },
    changeValueMultiple(value, key,options,indexKey) {
      if(Array.isArray(value)) {
        let item = value.map(oi => {return options.find(ex => ex[indexKey] === oi)})
        this.$emit("changeValueMultiple", {
          key,
          value,
          item
        });
      } else {
        let item = [value].map(oi => {return options.find(ex => ex[indexKey] === oi)})
        let newArr = [value]
        this.$emit("changeValueMultiple", {
          key,
          newArr,
          item
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep {
  .el-cascader {
    width: 100%;
  }

  .rich-text {
    img {
      width: 100%;
    }
  }
  .el-range-editor.el-input__inner{
    width: 100%;
  }
}
</style>
